import React from 'react';

import Select from '../../shared/Select';
import Input from '../../shared/Input';

const SurgeonsFilters = (props) => {
  const {
    procedure,
    procedures = [],
    setProcedure,
    search,
    setSearch
  } = props;

  return (
    <div className="settings-cmp__filters--main">
      <div style={{ width: 400 }}>
        <Input
          type="search"
          placeholder="Search Surgeons"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className='settings-cmp__filters'>
        <Select
          value={procedure}
          onChange={setProcedure}
          options={procedures?.map((p) => ({ label: p.name, value: p.id }))}
          defaultLabel={`All procedures (${procedures?.length})`}
          width={300}
        />
      </div>
    </div>
  )
};

export default SurgeonsFilters;
